export interface ReceivePriceResultLegacy {
  [accommodationId: number]: {
    matchingSuggestion: unknown;
    alternativeSuggestions: unknown;
  };
}

export const FETCH_PRICES_REQUEST = 'FETCH_PRICES_REQUEST';
export const FETCH_PRICES_SUCCESS = 'FETCH_PRICES_SUCCESS';
export const FETCH_PRICES_FAILURE = 'FETCH_PRICES_FAILURE';
export const INVALIDATE_PRICES = 'INVALIDATE_PRICES';

export interface ActionFetchPricesRequest {
  type: typeof FETCH_PRICES_REQUEST;
  loading: number[];
  accIds: number[];
}

export interface ActionFetchPricesSuccess {
  type: typeof FETCH_PRICES_SUCCESS;
  loading: number[];
  accIds: number[];
  prices: ReceivePriceResultLegacy;
}

export interface ActionFetchPricesFailure {
  type: typeof FETCH_PRICES_FAILURE;
  loading: number[];
  accIds: number[];
}

export interface ActionInvalidatePrices {
  type: typeof INVALIDATE_PRICES;
  accIds: number[];
}

export type PriceActions =
  | ActionFetchPricesRequest
  | ActionFetchPricesSuccess
  | ActionFetchPricesFailure
  | ActionInvalidatePrices;

export default {
  FETCH_PRICES_REQUEST,
  FETCH_PRICES_SUCCESS,
  FETCH_PRICES_FAILURE,
  INVALIDATE_PRICES,
};
